import { TextField } from 'mui-rff';
import React from 'react';

import Form from '@dashboard/components/form/Form';
import PermissionTooltip from '@dashboard/components/PermissionTooltip';
import { useUpdatePlatformBillingInformationMutation } from '@dashboard/generated/wp/platform';
import { Box, Button, Stack, Typography } from '@mui/material';

import { usePermission } from '../hooks';

type Props = {
  initialValues: {
    billingEmailAddress: string;
  };
};
export default function BillingEmailAddressForm({ initialValues }: Props): JsxNode {
  const [updateBillingInformation, { loading }] = useUpdatePlatformBillingInformationMutation();

  const permission = usePermission('updateSubscription');

  function onSubmit(d: { billingEmailAddress: string }) {
    const { billingEmailAddress } = d;
    updateBillingInformation({ variables: { billingEmailAddress } });
  }

  return (
    <Form successMessage="Billing information saved" initialValues={initialValues} onSubmit={onSubmit}>
      <Stack spacing={3}>
        <Box component="fieldset">
          <Typography variant="overline" color="text.secondary">
            Contact
          </Typography>
          <TextField
            name="billingEmailAddress"
            label="Billing email"
            fullWidth
            disabled={loading || !permission}
            margin="dense"
            helperText="This is where we'll send invoices and receipts."
          />
        </Box>
        <Box>
          <PermissionTooltip span name="updateSubscription">
            <Button disabled={loading || !permission} type="submit" variant="contained">
              Save
            </Button>
          </PermissionTooltip>
        </Box>
      </Stack>
    </Form>
  );
}
